import { useToast } from '@chakra-ui/react';
import React from 'react';
import { Formik } from 'formik';
import { localise, templateReplace } from '../../../services/lang/lang';
import useGenericMutationUseCase from '../../../hooks/usecases/generic/useGenericMutationUseCase';
import { useCreateNote } from '../../../services/api/generated/client';
import { capitalise } from '../../../services/text/format';
import Notes from './Notes';
const NotesWrapper = ({ onNotesMutated, model, type, ...rest }) => {
    const toast = useToast();
    const initialValues = {
        content: '',
    };
    const capitalised = capitalise(type);
    const noteableType = `App\\Models\\${capitalised}`;
    const createNoteUseCase = useGenericMutationUseCase(useCreateNote);
    const handleAddNote = (values, helpers) => {
        createNoteUseCase.execute({
            data: {
                content: values.content,
                noteable_id: model.id,
                noteable_type: noteableType,
            },
        }, helpers, {
            onSuccess: () => {
                onNotesMutated?.();
                helpers.resetForm();
                toast({
                    title: templateReplace(localise('NOTE_CREATED'), {
                        noun: capitalised,
                    }),
                    status: 'success',
                    isClosable: true,
                    duration: 1000,
                });
            },
        });
    };
    return (React.createElement(Formik, { initialValues: initialValues, onSubmit: handleAddNote },
        React.createElement(Notes, { onNotesMutated: onNotesMutated, ...rest })));
};
export default NotesWrapper;
